import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=d259e096&"
import script from "./Meals.js?vue&type=script&lang=js&"
export * from "./Meals.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports